import UpdatePasswordView from './pages/update-password'

import AdvertListPage from './pages/advert/list'
import HotCityPage from './pages/advert/hot-city'
import RecommendRoomPage from './pages/advert/recommend-room'
import ArticleListPage from './pages/advert/article-list'
import ArticleEditPage from './pages/advert/article-edit'
import VideoListPage from './pages/advert/video-list'



import TrainingListPage from './pages/cleaner/training-list'
import AccountListPage from './pages/cleaner/account-list'
import housekeeperAccountEditPage from './pages/cleaner/housekeeper-account-edit/index'

import XbedChannelHotelListPage from './pages/ota/list'
import XbedChannelHotelDetailPage from './pages/ota/hotel-detail'
import XbedChannelRoomTypeDetailPage from './pages/ota/roomtype-detail'
import SMSPage from './pages/order/sms'
import PayOrderPage from './pages/order/pay-order'

import OrderReportPage from './pages/report/order-report'
import ReportImportRecordsPage from './pages/report/import-records'
import OrderListPage from './pages/order/order-list'
import OrderDetailPage from './pages/order/order_detail/order-detail'
import FrontOrderPage from './pages/order/front-order' //前台下单
import createNewOrderPage from './pages/order/create-order' //代下单
import StopSheetPage from './pages/order/stop-sheet'
import ImportRecord from './pages/order/import-record'
import ReplaceReport from './pages/report/replace-report'
import SupplementaryOrder from './pages/order/supplementary-order'  // 补录订单

import MiniReport from './pages/report/mini-report'

import InvoiceList from './pages/order/invoice' //发票管理
import InvoiceManage from './pages/order/invoiceManage' //订单开票管理

import ShortRefundsListPage from './pages/order/short-rent-list.vue' //短租退款单
import StarClubPage from './pages/blue-hoster/star-club/index.vue' //星创俱乐部

import DeveloperTeam from './pages/blue-hoster/developer-team.vue' // 开发队伍
import CleanOrderListPage from './pages/cleaner/order-list'
import CleanGoodsListPage from './pages/cleaner/goods-list.vue'
import CleanItemListPage from './pages/cleaner/item-list.vue'
import CleanTypeListPage from './pages/cleaner/type-list.vue'
import HousekeeperBillList from './pages/cleaner/housekeeperBill-list.vue'
import CleaningTaskList from "./pages/cleaner/cleaningTask-list.vue"  //新增（月结清洁账单列表）
import PaymentDetails from './pages/cleaner/payment-details.vue'
import RoomSort from './pages/advert/roomSort'

import OrderResourcePage from './pages/order/order-resource.vue'
import RefundsListPage from './pages/order/refunds-list.vue'
import OwnerOrderListPage from './pages/order/owner-order-list.vue'

import FeizhuChannelHotelListPage from './pages/ota/feizhu/list'
import FeizhuChannelHotelDetailPage from './pages/ota/feizhu/hotel-detail'
import FeizhuChannelRoomTypeDetailPage from './pages/ota/feizhu/roomtype-detail'

import DeviceListPage from './pages/smart-device/self-service-machine/index'
import DeviceDetailPage from './pages/smart-device/self-service-machine/detail'

import VipPage from './pages/vip/management-list'
import VipDetailPage from './pages/vip/vip-detail'
import ChannelAnalysisPage from './pages/android-channel/channel-analysis'

import InformationManage from './pages/business-management/index'
import QueryDetail from './pages/business-management/company-details'
import PopularizeReportForm from './pages/business-management/promotion-report'
import ChannelList from './pages/wechat/channel-list'
import TariffList from './pages/wechat/tariff-list'
import MinprogramManage from './pages/wechat/minprogram-manage'

import LockListPage from './pages/smart-device/samrt-lock/index'
import LockDetailPage from './pages/smart-device/samrt-lock/detail'
import LockAccountManage from './pages/smart-device/lock-account-manage'
import SmartOpenOnline from './pages/smart-device/open-online'
import DictGroupListPage from './pages/smart-device/dictionary-managed/index.vue'  //字典管理

import ConsumptionListPage from './pages/order/consumption-list' // 入账单列表
import OwnerRevenuePage from './pages/report/owner-revenue' // 业主营收报表
import BlueOwnerReportPage from './pages/report/blue-owner-report' // 蓝主人业主报表
import LateCheckOutOrder from "./pages/order/late-check-out-order"

import BillStatementPage from './pages/report/bill-statement' // 账单明细
import MonthlySettleDetailPage from './pages/report/bill-statement/monthlySettleDetail' // 月度结算明细
import ManualRecordPage from './pages/report/bill-statement/manualRecord' // 手工入账导入记录

import centerManagementPage from './pages/basic-data-management/center-management' //中心仓管理
import MenuList from './pages/wechat/menu-manage'

import RoleManage from './pages/system/role-manage'
import EditRoomStatus from './pages/system/editRoomStatus.vue'
import EditRoomElecStatus from './pages/room/editRoomElecStatus.vue'
import CompanyInfo from './pages/blue-hoster/company-info.vue'

import ChainList from './pages/basic-data-management/hotel-list'

// 管控表
import AdjustmentList from './pages/adjustment-sheet/adjustment-list'
import AddAdjustsheet from './pages/adjustment-sheet/add-adjustsheet'
import AdjustmentDetail from './pages/adjustment-sheet/adjustment-order-detail'

//物资领用表
import MaterialCollarList from './pages/cleaner/materialCollar-list'
// 房间出入库表
import Inventory from './pages/cleaner/inventory'
import InventoryDetails from './pages/cleaner/inventory/inventory-details.vue'
// 管家出入库表
import HousekeepingMaterialsList from './pages/cleaner/housekeepingMaterials-list.vue'
import MaterialUpdateDetailsList from './pages/cleaner/materialUpdateDetails-list.vue'
// 值班单账单
import DutyBillList from './pages/cleaner/dutyBill-list.vue'
import DutyOrderList from './pages/cleaner/dutyOrder-list.vue'
// 艺龙
import ElongRoomSourceOrderList from './pages/elong/roomSourceOrderList';
import ElongOrderDetail from './pages/elong/orderDetail';
import ElongTransaction from './pages/elong/transactionRecord';
import PromotionReport from './pages/elong/promotionReport'
// 蓝主人-业主
import HosterList from './pages/blue-hoster/hoster-list'

//PMS结算账单报表
import pmsCheckReporPage from './pages/report/pms-check-repors'

// 营销管理
import CodeStore from './pages/marketing/code-store'
import CouponCardList from './pages/marketing/coupon-card-list.vue'//所有卡券
import ActivationList from './pages/marketing/activationList.vue'
import ActivityDetailView from './pages/marketing/activityDetailView.vue'
import ActivityEditView from './pages/marketing/activityEditView.vue'
import ActivityList from './pages/marketing/activityList.vue'
import ActivityRewardContentList from './pages/marketing/activityRewardContentList.vue'
import ActivityManualReward from './pages/marketing/activityManualReward.vue'
import ActivityRewardList from './pages/marketing/activityRewardList.vue'
import CouponCardUsedRecord from './pages/marketing/couponCardUsedRecord.vue'
import MarketingExcludeRoom from './pages/marketing/marketingExcludeRoom.vue'
import PromoCodeList from './pages/marketing/promoCodeList.vue'
import PromoCodeEdit from './pages/marketing/promoCodeEdit.vue'
import Join from './pages/marketing/join.vue'
import TagGroupList from './pages/marketing/tagGroupList.vue'
import TagList from './pages/marketing/tagList.vue'
import TagDetailList from './pages/marketing/tagDetailList.vue'
import UserCouponManage from './pages/marketing/userCouponManage.vue'

// 丽家会-清洁账单列表
import cleanBillList from './pages/cleaner/clean-bill-list.vue'
import additionalFee from './pages/cleaner/additional-fee'

// 消息中心 - 公告通知
import NoticeListPage from './pages/message/notice-list'

import DelegateState from './pages/delegate-management/delegate-state'
import DelegateRecord from './pages/delegate-management/delegate-record'

// 门店经营利润表
import ChainReportPage from './pages/report/chain-report'
import ChainReportDetailPage from './pages/report/chain-report/chain-reportDetail'

export default {
  system: {
    updatePasswordVue: {
      dom: '#updatePasswordVue',
      page: UpdatePasswordView
    },
    roleManage: {
      dom: '#roleManage',
      page: RoleManage
    },
    editRoomStatus: {
      dom: '#editRoomStatus',
      page: EditRoomStatus
    },
    editRoomElecStatus: {
      dom: '#editRoomElecStatus',
      page: EditRoomElecStatus
    }
  },
  // 广告
  advert: {
    advertList: {
      dom: '#advertList',
      page: AdvertListPage
    },
    hotCity: {
      dom: '#hotCity',
      page: HotCityPage
    },
    recommendRoom: {
      dom: '#recommendRoom',
      page: RecommendRoomPage
    },
    articleList: {
      dom: '#articleList',
      page: ArticleListPage
    },
    articleEdit: {
      dom: '#articleEdit',
      page: ArticleEditPage
    },
    videoList: {
      dom: '#videoList',
      page: VideoListPage
    },
    roomSort: {
      dom: '#roomSort',
      page: RoomSort
    }
  },
  // 丽家会
  cleaner: {
    trainingList: {
      dom: '#trainingList',
      page: TrainingListPage
    },
    accountEdit: {
      dom: '#accountEdit',
      page: housekeeperAccountEditPage
    }, //修改管家账号
    accountList: {
      dom: '#accountList',
      page: AccountListPage
    },
    orderList: {
      dom: '#orderList',
      page: CleanOrderListPage
    },
    goodsList: {
      dom: '#goodsList',
      page: CleanGoodsListPage
    },
    itemList: {
      dom: '#itemList',
      page: CleanItemListPage
    },
    typeList: {
      dom: '#typeList',
      page: CleanTypeListPage
    },
    housekeeperBillList: {
      dom: '#housekeeperBillList',
      page: HousekeeperBillList
    },
    cleaningTaskList: {
      dom: "#cleaningTaskList",
      page: CleaningTaskList
    },
    paymentDetails: {
      dom: '#paymentDetails',
      page: PaymentDetails
    },
    materialCollarList: {
      dom: '#materialCollarList',
      page: MaterialCollarList
    },
    inventory: {
      dom: '#inventory',
      page: Inventory
    },
    inventoryDetails: {
      dom: '#inventoryDetails',
      page: InventoryDetails
    },
    housekeepingMaterialsList: {
      dom: '#housekeepingMaterialsList',
      page: HousekeepingMaterialsList
    },
    materialUpdateDetailsList: {
      dom: '#materialUpdateDetailsList',
      page: MaterialUpdateDetailsList
    },
    dutyBillList: {
      dom: '#dutyBillList',
      page: DutyBillList
    },
    dutyOrderList: {
      dom: '#dutyOrderList',
      page: DutyOrderList
    },
    cleanBillList: {
      dom: '#cleanBillList',
      page: cleanBillList
    },
    additionalFee: {
      dom: '#additionalFee',
      page: additionalFee
    }
  },
  // OTA
  ota: {
    xbedChannelHotelList: {
      dom: '#xbedChannelHotelList',
      page: XbedChannelHotelListPage
    },
    xbedChannelHotelDetail: {
      dom: '#xbedChannelHotelDetail',
      page: XbedChannelHotelDetailPage
    },
    xbedChannelRoomTypeDetail: {
      dom: '#xbedChannelRoomTypeDetail',
      page: XbedChannelRoomTypeDetailPage
    },
    feizhuChannelHotelList: {
      dom: '#feizhuChannelHotelList',
      page: FeizhuChannelHotelListPage
    },
    feizhuChannelHotelDetail: {
      dom: '#feizhuChannelHotelDetail',
      page: FeizhuChannelHotelDetailPage
    },
    feizhuChannelRoomTypeDetail: {
      dom: '#feizhuChannelRoomTypeDetail',
      page: FeizhuChannelRoomTypeDetailPage
    },
  },
  // 订单类
  order: {
    sendMessageView: {
      dom: '#sendMessageView',
      page: SMSPage
    },
    payListList: {
      dom: '#payListList',
      page: PayOrderPage
    },
    newOrderList: {
      dom: '#newOrderList',
      page: OrderListPage
    },
    newOrderDetail: {
      dom: '#newOrderDetail',
      page: OrderDetailPage
    },
    frontDestOrder: {
      dom: '#frontDestOrder',
      page: FrontOrderPage
    },
    createNewOrderPage: {
      dom: '#createNewOrderPage',
      page: createNewOrderPage
    },
    roomStopSheetList: {
      dom: '#roomStopSheetList',
      page: StopSheetPage
    },
    importRecord: {
      dom: '#importRecord',
      page: ImportRecord
    },
    supplementaryOrder: {
      dom: '#supplementaryOrder',
      page: SupplementaryOrder
    },
    lateCheckOutOrder: {
      dom: '#lateCheckOutOrder',
      page: LateCheckOutOrder
    },
    invoiceList: {
      dom: '#invoiceList',
      page: InvoiceList
    },
    shortRefundsList: {
      dom: '#shortRefundsList',
      page: ShortRefundsListPage
    },
    orderResource: {
      dom: '#orderResource',
      page: OrderResourcePage
    },
    refundsList: {
      dom: '#refundsList',
      page: RefundsListPage
    },
    ownerOrderList: {
      dom: '#ownerOrderList',
      page: OwnerOrderListPage
    },
    deviceList: {
      dom: '#deviceList',
      page: DeviceListPage
    },
    deviceDetail: {
      dom: '#deviceDetail',
      page: DeviceDetailPage
    },
    informationManage: {
      dom: '#informationManage',
      page: InformationManage
    },
    popularizeReportForm: {
      dom: '#popularizeReportForm',
      page: PopularizeReportForm
    },
    queryDetail: {
      dom: '#queryDetail',
      page: QueryDetail
    },
    channelAnalysis: {
      dom: '#channelAnalysis',
      page: ChannelAnalysisPage
    },
    lockDetail: {
      dom: '#lockDetail',
      page: LockDetailPage
    },
    lockList: {
      dom: '#lockList',
      page: LockListPage
    },
    lockAccount: {
      dom: '#lockAccount',
      page: LockAccountManage
    },
    openOnline: {
      dom: '#openOnline',
      page: SmartOpenOnline
    },
    consumptionList: {
      dom: '#consumptionList',
      page: ConsumptionListPage
    },
    invoiceManage: {
      dom: '#invoiceManage',
      page: InvoiceManage
    },
    adjustmentList: {
      dom: '#adjustmentList',
      page: AdjustmentList
    },
    addAdjustsheet: {
      dom: '#addAdjustsheet',
      page: AddAdjustsheet
    },
    adjustmentDetail: {
      dom: '#adjustmentDetail',
      page: AdjustmentDetail
    },
    chainList: {
      dom: '#chainList',
      page: ChainList
    }
  },
  //艺龙
  elong: {
    elongRoomSourceOrderList: {
      dom: '#elongRoomSourceOrderList',
      page: ElongRoomSourceOrderList
    },
    elongOrderDetail: {
      dom: '#elongOrderDetail',
      page: ElongOrderDetail
    },
    elongTransaction: {
      dom: '#elongTransaction',
      page: ElongTransaction
    },
    promotionReport: {
      dom: '#promotionReport',
      page: PromotionReport
    }
  },
  // 报表
  report: {
    listCheckResult: {
      dom: '#listCheckResult',
      page: ReportImportRecordsPage
    },
    orderReport: {
      dom: '#orderReport',
      page: OrderReportPage
    },
    replaceReport: {
      dom: '#replaceReport',
      page: ReplaceReport
    },
    miniReport: {
      dom: '#miniReport',
      page: MiniReport
    },
    ownerRevenue: {
      dom: '#ownerRevenue',
      page: OwnerRevenuePage
    },
    blueOwnerReport: {
      dom: '#blueOwnerReport',
      page: BlueOwnerReportPage
    },
    pmsCheckRepor: {
      dom: '#pmsCheckRepor',
      page: pmsCheckReporPage
    },
    billStatement: {
      dom: '#billStatement',
      page: BillStatementPage
    },
    monthlySettleDetail: {
      dom: '#monthlySettleDetail',
      page: MonthlySettleDetailPage
    },
    manualRecord: {
      dom: '#manualRecord',
      page: ManualRecordPage
    },
    chainReport: {
      dom: '#chainReport',
      page: ChainReportPage
    },
    chainReportDetail: {
      dom: '#chainReportDetail',
      page: ChainReportDetailPage
    },
  },
  // 营销管理
  marketing: {
    codeStore: {
      dom: '#codeStore',
      page: CodeStore
    },
    activationList: {
      dom: '#activationList',
      page: ActivationList
    },
    activityDetailView: {
      dom: '#activityDetailView',
      page: ActivityDetailView
    },
    activityEditView: {
      dom: '#activityEditView',
      page: ActivityEditView
    },
    activityList: {
      dom: '#activityList',
      page: ActivityList
    },
    activityRewardContentList: {
      dom: '#activityRewardContentList',
      page: ActivityRewardContentList
    },
    activityManualReward: {
      dom: '#activityManualReward',
      page: ActivityManualReward
    },
    tagGroupList: {
      dom: '#tagGroupList',
      page: TagGroupList
    },
    tagList: {
      dom: '#tagList',
      page: TagList
    },
    tagDetailList: {
      dom: '#tagDetailList',
      page: TagDetailList
    },
    userCouponManage: {
      dom: '#userCouponManage',
      page: UserCouponManage
    },
    activityRewardList: {
      dom: '#activityRewardList',
      page: ActivityRewardList
    },
    couponCardUsedRecord: {
      dom: '#couponCardUsedRecord',
      page: CouponCardUsedRecord
    },
    marketingExcludeRoom: {
      dom: '#marketingExcludeRoom',
      page: MarketingExcludeRoom
    },
    promoCodeList: {
      dom: '#promoCodeList',
      page: PromoCodeList
    },
    promoCodeEdit: {
      dom: '#promoCodeEdit',
      page: PromoCodeEdit
    },
    couponCardList: {
      dom: '#couponCardList',
      page: CouponCardList
    },
    // 加盟信息 - 业主加盟
    join: {
      dom: '#join',
      page: Join
    },
    // 加盟信息 - 区域战略合作
    joinArea: {
      dom: '#joinArea',
      page: Join
    }

  },
  // 蓝主人
  blueHoster: {
    developerTeam: {
      dom: '#developerTeam',
      page: DeveloperTeam
    },
    starClub: {
      dom: '#starClub',
      page: StarClubPage
    },
    companyInfo: {
      dom: '#companyInfo',
      page: CompanyInfo
    },
    hosterList: {
      dom: '#hosterList',
      page: HosterList
    }
  },
  // 会员管理
  vip: {
    vipList: {
      dom: '#vipList',
      page: VipPage
    },
    vipDetail: {
      dom: '#vipDetail',
      page: VipDetailPage
    }
  },
  //微信
  wechat: {
    channelList: {
      dom: '#channelList',
      page: ChannelList
    },
    tariffList: {
      dom: '#tariffList',
      page: TariffList
    },
    menuList: {
      dom: '#menuList',
      page: MenuList
    },
    minprogramManage: {
      dom: '#minprogramManage',
      page: MinprogramManage
    }
  },
  //基础数据
  baseInfo: {
    centerDataList: {
      dom: '#centerDataList',
      page: centerManagementPage
    },
    // 消息中心 - 通知公告
    noticeList: {
      dom: '#noticeList',
      page: NoticeListPage
    },
    //店长值班状态
    delegateState: {
      dom: '#delegateState',
      page: DelegateState
    },
    //值班记录
    delegateRecord: {
      dom: '#delegateRecord',
      page: DelegateRecord
    }
  },
  //  IT服务管理
  itsm: {
    dictGroupList: {
      dom: '#dictGroupList',
      page: DictGroupListPage
    }
  },

}



// WEBPACK FOOTER //
// ./src/pages-mapper.js